// src/components/StackTag.js
import styled from 'styled-components';
import { colors, fonts, fontSizes, radii, space, duration, ease } from '../styles/tokens';

export const StackTag = styled.span`
  display: inline-block;
  padding: ${space[0.5]} ${space[1]};
  font-family: ${fonts.mono};
  font-size: ${fontSizes.xs};
  color: ${colors.accent};
  background: rgba(100, 255, 218, 0.08);
  border-radius: ${radii.sm};
  transition: background ${duration.fast} ${ease.soft};
  &:hover { background: rgba(100, 255, 218, 0.15); }
`;

export const StackTagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${space[1]};
`;
